import React, { useRef, useState } from 'react';
import './PaymentDetail.css';
import { getSessionStorage, removeSessionStorage } from '../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { useApiServices } from '../../services/endpoints/ApiEndpoint';
import Image from '../../components/image/Image';
import { useAlert } from '../../components/alert-context/AlertContext';
import Button from '../../components/button/Button';

const PaymentDetail: React.FC = () => {
  const alert = useAlert();
  const navigate = useNavigate();
  const { UploadFileAsync, CreatePaymentAsync } = useApiServices()
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [preview, setPreview] = useState<any>(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    const { result } = await UploadFileAsync(formData)
    setPreview(result);
  };

  const handleCopyAccountNumber = () => {
    navigator.clipboard.writeText("1298444077").catch(() => {});
  };

  const submit = async () => {
    const ids = getSessionStorage('i')
    if (ids) {
      const payload = {
        fileUploadIds: [preview.id],
        transactionIds: getSessionStorage('i'),
        paymentMethod: 'PromptPay',
        price: getSessionStorage('p')
      }
      const { isSuccess, result } = await CreatePaymentAsync(payload)
      if (isSuccess) {
        alert.success({
          message: 'ชำระเงินสำเร็จ', onConfirm: () => {
            const targetIds = ids.join(',')
            removeSessionStorage('i')
            removeSessionStorage('p')
            removeSessionStorage('r')
            navigate(`/order/${targetIds}`)
          }
        })
      } else {
        alert.error({
          message: result?.message ?? 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง'
        })
      }
    }
  }

  const addressString = (): string => {
    const address = getSessionStorage('a')
    if (!address) return ""
    return [address.addressLine1, address.addressLine2, address.postalCode, address.country]
      .filter(p => p && p.trim() !== "").join(", ");
  }

  return (
    <section className="pd-wrapper">
      <div className="pd-container lg:container lg:mx-auto">

        {/* Header */}
        <div className="pd-header">
          <h2 className="pd-title">ชำระเงิน</h2>
        </div>

        {/* Amount summary */}
        <div className="pd-section-label">ยอดชำระ</div>
        <div className="pd-card pd-summary-card">
          <div className="pd-summary-amount">
            <span className="pd-summary-label">ราคารวม</span>
            <span className="pd-summary-price">{getSessionStorage('p')?.toLocaleString()} บาท</span>
          </div>
          <div className="pd-ref-row">
            <span className="pd-ref-label">เลขอ้างอิง</span>
            <span className="pd-ref-value">{getSessionStorage('r')?.join(', ')}</span>
          </div>
        </div>

        {/* Bank info */}
        <div className="pd-section-label">ช่องทางชำระเงิน</div>
        <div className="pd-card pd-bank-card">
          <div className="pd-bank-row">
            <img src="/assets/images/logo-k-bank.png" alt="logo-k-bank" className="pd-bank-logo" />
            <div className="pd-bank-info">
              <div className="pd-bank-field">
                <p className="pd-bank-field-label">เลขที่บัญชี</p>
                <p className="pd-bank-field-value">129-844407-7</p>
              </div>
              <div className="pd-bank-field">
                <p className="pd-bank-field-label">ชื่อบัญชี</p>
                <p className="pd-bank-field-value">บริษัท คอนกรีต เดลิเวอรี่ จำกัด</p>
              </div>
            </div>
          </div>
          <div className="pd-bank-actions">
            <button onClick={handleCopyAccountNumber} className="pd-bank-action-btn">
              {/* <img src="/assets/icons/icon-park-outline-copy-link.svg" alt="copy" /> */}
              คัดลอกเลขบัญชี
            </button>
            <button className="pd-bank-action-btn">
              {/* <img src="/assets/icons/icon-phone-outline.svg" alt="phone" /> */}
              ติดต่อแอดมิน
            </button>
          </div>
        </div>

        {/* Slip upload */}
        <div className="pd-section-label">แนบสลิป</div>
        <div className="pd-card pd-slip-card">
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
          {!preview && (
            <Button onClick={handleClick} variant="primary" fullWidth>แนบสลิป</Button>
          )}
          {preview && (
            <>
              <div className="pd-slip-preview">
                <Image id={preview.id} className="w-full h-auto" />
              </div>
              <span className="pd-slip-filename">{preview.originalFileName}</span>
              <div className="pd-slip-actions">
                <Button onClick={handleClick} variant="secondary" fullWidth>เลือกใหม่</Button>
                <Button onClick={submit} variant="primary" fullWidth>ถัดไป</Button>
              </div>
            </>
          )}
        </div>

        {/* Address */}
        <div className="pd-section-label">ที่อยู่จัดส่ง</div>
        <div className="pd-card pd-address-card">
          <img src="/assets/images/image-address.png" alt="address" className="pd-address-img" />
          <div className="pd-address-info">
            <p className="pd-address-name">{getSessionStorage('a')?.name || 'ที่อยู่'}</p>
            <p className="pd-address-text">{addressString()}</p>
          </div>
        </div>

        {/* Back */}
        <div className="pd-actions">
          <Button variant="secondary" fullWidth onClick={() => navigate(-1)}>ย้อนกลับ</Button>
        </div>

      </div>
    </section>
  )
}

export default PaymentDetail;
